/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import CardImg from "../../assets/greens.png";
import {
  addCartEntries,
  getCartEntries,
} from "../../services/commerceServices/cartServices";
import MessageStrip from "../shared-ui/message-strip";
import FoodDetails from "./food-details";
import ProductDetails from "./product-details";
import TipsDetails from "./tips-details";
import fallbackImage1 from "../../assets/fallbackImage1.png";
import { title } from "process";
import { utag, withUtag } from "../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";
import _ from "lodash";

// Interface for DetailsComponent State
interface DetailsComponentState {
  closeDetails: boolean;
  selectedOption: string;
  selectedHitState: any;
  hitStateDataState?: any;
  hitStateIndexState?: any;
  hitStateHeading?: any;
  hitStateSubTypeState?: any;
  selectedHitStateProduct?: any;
  selectedHitStateFood?: any;
  count?: number;
  type?: string;
  successfullyAdded: boolean;
  displayOutOfStock: boolean;
  productFailedAddToCart: boolean;
}

/**
 * DetailsComponent component.
 *
 * @namespace DetailsComponent
 */
class DetailsComponent extends React.Component<any, DetailsComponentState> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      closeDetails: false,
      selectedOption: "",
      selectedHitState: [],
      hitStateDataState: [],
      hitStateIndexState: 0,
      count: 0,
      successfullyAdded: false,
      displayOutOfStock: false,
      productFailedAddToCart: false,
    };
  }

  componentDidMount = () => {
    if (
      (this.state.hitStateDataState !== this.props?.hitStateData ||
        this.state.hitStateIndexState !== this.props?.hitStateIndex ||
        this.state.selectedOption !== this.props.hitStateHeading) &&
      this.props.hitStateType === "tips"
    ) {
      this.setState({
        hitStateDataState: this.props.hitStateData,
        type: this.props.hitStateType,
        selectedOption: this.props.hitStateHeading,
        //selectedOption: this.props.hitStateHeading === "card" ? "why" : "where",
        hitStateIndexState: this.props.hitStateIndex,
      });
      // if (this.props.hitStateHeading === "where") {
      //   this.setState({ selectedOption: "where" });
      // }
      // if (this.props.hitStateHeading === "card") {
      //   this.setState({ selectedOption: "why" });
      // }
      this.props?.hitStateData?.forEach((element: any, index: number) => {
        if (index === this.props.hitStateIndex) {
          this.setState({ selectedHitState: element, count: index });
        }
      });
    }

    if (
      (this.state.hitStateDataState !== this.props?.hitStateData ||
        this.state.hitStateIndexState !== this.props?.hitStateIndex) &&
      this.props.hitStateType === "product"
    ) {
      this.setState({
        hitStateDataState: this.props.hitStateData,
        // selectedOption: "why",
        hitStateIndexState: this.props.hitStateIndex,
      });
      let arr: any = [];
      this.props?.hitStateData?.forEach((element: any, index: number) => {
        if (index === this.props.hitStateIndex) {
          arr.push(element);
          this.setState({ selectedHitStateProduct: arr, count: index });
        }
      });
    }

    if (
      (this.state.hitStateDataState !== this.props?.hitStateData ||
        this.state.hitStateIndexState !== this.props?.hitStateIndex ||
        this.state.selectedOption !== this.props.hitStateHeading ||
        this.state.hitStateSubTypeState !== this.props.hitStateSubType) &&
      this.props.hitStateType === "food"
    ) {
      this.setState({
        hitStateDataState: this.props.hitStateData,
        type: this.props.hitStateType,
        selectedOption: this.props.hitStateHeading,
        hitStateSubTypeState: this.props.hitStateSubType,
        //selectedOption: this.props.hitStateHeading === "card" ? "why" : "where",
        hitStateIndexState: this.props.hitStateIndex,
      });
      // if (this.props.hitStateHeading === "where") {
      //   this.setState({ selectedOption: "where" });
      // }
      // if (this.props.hitStateHeading === "card") {
      //   this.setState({ selectedOption: "why" });
      // }
      this.props?.hitStateData?.forEach((element: any, index: number) => {
        if (index === this.props.hitStateIndex) {
          this.setState({ selectedHitStateFood: element, count: index });
        }
      });
    }
  };
  componentDidUpdate = () => {
    if (this.props.show) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
      document.addEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        true
      );
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
      document.removeEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        false
      );
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  handleOutOfStock = () => {
    this.setState(
      {
        displayOutOfStock: true,
      },
      () => setTimeout(() => this.setState({ displayOutOfStock: false }), 3000)
    );
  };

  handleClose = () => {
    let hashValues = _.split(window.location.hash, "/#");
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${hashValues[0]}`
    );

    this.setState(
      {
        closeDetails: true,
      },
      () => {
        this.props.handleClose();
      }
    );
  };
  handleCloseKeyPresss = (event: any) => {
    if (event.key === "Enter") {
      this.handleClose();
    }
  };
  handleOptionsClick = (selected: string) => {
    this.setState({
      selectedOption: selected,
    });
  };
  handleOptionsKeyPress = (event: any, selected: string) => {
    if (event.key === "Enter") {
      this.handleOptionsClick(selected);
    }
  };
  handleClickPrevious = () => {
    const count = this.state.count;
    let countNo: any = this.state.count;
    if (countNo > 0) {
      this.setState({
        count: countNo - 1,
      });
      if (this.props.hitStateType === "tips") {
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo - 1) {
            this.setState({ selectedHitState: element });
          }
        });
      }
      if (this.props.hitStateType === "food") {
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo - 1) {
            this.setState({ selectedHitStateFood: element });
          }
        });
      }
      if (this.props.hitStateType === "product") {
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo - 1) {
            let arr: any = [];

            arr.push(element);
            this.setState({ selectedHitStateProduct: arr });
          }
        });
      }
    }
  };
  handleClickPreviousKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleClickPrevious();
    }
  };

  handleClickNext = () => {
    let countNo: any = this.state.count;
    if (countNo < this.props.hitStateData.length - 1) {
      this.setState({
        count: countNo + 1,
      });
      if (this.props.hitStateType === "tips") {
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo + 1) {
            this.setState({ selectedHitState: element });
          }
        });
      }

      if (this.props.hitStateType === "food") {
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo + 1) {
            this.setState({ selectedHitStateFood: element });
          }
        });
      }

      if (this.props.hitStateType === "product") {
        let arr: any = [];
        this.props.hitStateData.forEach((element: any, index: number) => {
          if (index === countNo + 1) {
            arr.push(element);

            this.setState({ selectedHitStateProduct: arr });
          }
        });
      }
    }

    //count=count+1;
  };

  getCartProductsList = async () => {
    await getCartEntries().then((response: any) => {
      let entries: any = [];
      response &&
        response.entries.map((item: any) => {
          entries.push(item);
        });
      // this.setState({
      //   cartProductsList: entries,
      // });
    });
  };

  handleDetailsCart = (productCode: number, quantity: number) => {
    addCartEntries(productCode, quantity).then((response: any) => {
      if (response) {
        //cart addition event
        let authObj = getUtagAuthObject();
        let sessionObj = getUtagSessionObject();
        let needStatesObj = getUtagNeedStates();
        let obj = {
          page_name: window.location.pathname.includes("summary")
            ? "My Products"
            : "My Results",
          event_name: "cart_addition",
          product_brand: [response?.entry?.product?.brandName],
          product_businessVolume: [
            response?.entry?.value?.businessVolume?.toString(),
          ],
          product_id: [response?.entry?.product?.code],
          product_name: [response?.entry?.product?.name],
          product_pointValue: [response?.entry?.value?.pointValue?.toString()],
          product_referrer: ["wellness-guide"],
          product_unitPrice: [response?.entry?.basePrice?.value?.toString()],
          product_units: [response?.quantityAdded?.toString()],
          wellness_filter: this.props?.hitStateSubType + "-products",
        };
        let updatedObj = _.merge(
          localStorage.getItem("user-info") ? authObj : {},
          localStorage.getObj("reco-result") ? needStatesObj : {},
          sessionObj,
          obj
        );
        withUtag().then((utag) => utag.link(updatedObj));
        this.getCartProductsList();
        this.setState(
          {
            successfullyAdded: true,
          },
          () => setTimeout(() => this.setState({ successfullyAdded: false }), 3000)
        );
      } else {
        this.setState(
          {
            productFailedAddToCart: true,
          },
          () => setTimeout(() => this.setState({ productFailedAddToCart: false }), 3000)
        );
      }
    });
  };

  handleClickNextKeyPress = (event: any) => {
    if (event.key === "Enter") {
      this.handleClickNext();
    }
  };
  render() {
    const {
      selectedType,
      hitStateData,
      hitStateIndex,
      hitStateType,
      hitStateSubType,
    } = this.props;
    const {
      selectedHitState,
      count,
      selectedHitStateProduct,
      selectedHitStateFood,
      hitStateSubTypeState,
      successfullyAdded,
      displayOutOfStock,
      productFailedAddToCart,
    } = this.state;

    const { selectedOption } = this.state;
    const fallBackImageCard: any =
      localStorage.getObj("results-info")?.fallbackimagecard?.url;

    let hamburgerClass = "inner-wrapper hide";
    if (this.state.closeDetails) {
      hamburgerClass = "inner-wrapper animated slideInRight close-details";
    }
    if (this.props.show) {
      hamburgerClass = "inner-wrapper animated slideInLeft";
    }
    return (
      <div
        className={
          selectedType && selectedType === "product"
            ? "details-container product-details-container"
            : "details-container"
        }
      >
        {/* Add to Cart Success Message Start */}
        {successfullyAdded ? (
          <MessageStrip
            messageText={this.props.t("common.user_added_product_to_cart")}
          />
        ) : null}
        {/* Add to Cart Success Message Ends */}

        {displayOutOfStock ? (
          <MessageStrip
            messageText={this.props.t("common.out_of_stock")}
            warning={true}
          />
        ) : null}

        {/* Display product fail Message Start */}
        {productFailedAddToCart ? (
          <MessageStrip
            messageText={this.props.t("common.product_failed_add_to_cart")}
            warning={true}
          />        ) : null}
        {/* display out of stock Message Ends */}

        <div className={this.props.show ? "overlay" : "overlay hide"}></div>
        <div
          className={hamburgerClass}
          ref={(node) => {
            this.node = node;
          }}
        >
          <div
            tabIndex={0}
            role="button"
            aria-label="details close"
            className="details-close"
            onClick={this.handleClose}
            onKeyPress={(e) => this.handleCloseKeyPresss(e)}
          >
            <span className="icon close-icon"></span>
          </div>
          {selectedType && selectedType !== "product" ? (
            <>
              {/* Foods and Tips Details Section Start */}
              <div className="details-header-wrapper">
                {hitStateType === "tips" && (
                  <div id="details-image" className="header-title">
                    {selectedHitState?.tip_title}
                  </div>
                )}
                {hitStateType === "food" && (
                  <div id="details-image" className="header-title">
                    {selectedHitStateFood?.data?.food_title}
                  </div>
                )}
                {/* <div className="header-title">Leafy Greens</div> */}
                <div className="header-options" style={{ zIndex: 1 }}>
                {/* <div
                      tabIndex={0}
                      role="button"
                      className={
                        selectedOption === "" || selectedOption === "recipe"
                            ? "option active"
                            : "option"
                        }
                        onClick={() => this.handleOptionsClick("why")}
                        onKeyPress={(e) =>
                          this.handleOptionsKeyPress(e, "why")
                        }
                      >
                        {this.props.t("common.recipe")}
                      </div> */}
                  {selectedType &&
                    selectedType === "food" &&
                    hitStateSubTypeState === "eat" && (
                      <div
                      tabIndex={0}
                      role="button"
                      className={
                        selectedOption === "why" ? "option active" : "option"
                      }
                      onClick={() => this.handleOptionsClick("why")}
                      onKeyPress={(e) => this.handleOptionsKeyPress(e, "why")}
                    >
                      {this.props.t("common.why")}
                    </div>
                    )}
                  {selectedType && selectedType === "tips" && (
                    <div
                      tabIndex={0}
                      role="button"
                      className={
                        selectedOption === "" || selectedOption === "where"
                          ? "option active"
                          : "option"
                      }
                      onClick={() => this.handleOptionsClick("where")}
                      onKeyPress={(e) => this.handleOptionsKeyPress(e, "where")}
                    >
                      {this.props.t("common.where_to_start")}
                    </div>
                  )}
                </div>
              </div>
              <div className="details-wrapper">
                {hitStateType === "tips" && (
                  <div className="deatil-image-wrapper">
                    <img
                      tabIndex={-1}
                      role="img"
                      aria-labelledby="details-image"
                      className={"deatil-img"}
                      src={
                        selectedHitState?.why_image?.url
                          ? selectedHitState?.why_image?.url
                          : fallBackImageCard
                      }
                      alt=""
                    />
                  </div>
                )}

                {hitStateType === "food" && selectedOption === "why" && (
                  <div className="deatil-image-wrapper">
                    <img
                      tabIndex={-1}
                      role="img"
                      aria-labelledby="details-image"
                      className={"deatil-img"}
                      src={
                        selectedHitStateFood?.data?.why_image?.url
                          ? selectedHitStateFood?.data?.why_image?.url
                          : fallBackImageCard
                      }
                      alt=""
                    />
                  </div>
                )}

                {hitStateType === "food" &&
                  selectedOption === "recipe" &&
                  selectedHitStateFood &&
                  selectedHitStateFood?.recipes && (
                    <div className="deatil-image-wrapper">
                      <img
                        tabIndex={-1}
                        role="img"
                        aria-labelledby="details-image"
                        className={"deatil-img"}
                        src={
                          selectedHitStateFood?.recipes?.mainImage
                            ? selectedHitStateFood?.recipes?.mainImage
                            : fallBackImageCard
                        }
                        alt=""
                      />
                    </div>
                  )}

                {/* Food Details Start */}
                {selectedType && selectedType === "food" ? (
                  <FoodDetails
                    {...this.props}
                    foodsData={selectedHitStateFood}
                    hitStateSubType={this.props.hitStateSubType}
                    selectedOption={
                      this.props?.hitState?.hitStateHeading || selectedOption
                    }
                    // selectedOption={
                    //   selectedOption === "" || selectedOption === "where"
                    //     ? "recipe"
                    //     : selectedOption
                    // }
                  />
                ) : null}
                {/* Food Details Ends */}

                {/* Tips Details Start */}
                {selectedType && selectedType === "tips" ? (
                  <TipsDetails
                    data={selectedHitState}
                    selectedOption={
                      this.props?.hitState?.hitStateHeading || selectedOption
                    }
                  />
                ) : null}
                {/* Tips Details Ends */}
              </div>
              {hitStateData && hitStateData.length > 1 && (
                <div className="details-pagination-wrapper">
                  {/* <span className="icon prev-icon disable"></span> */}
                  <span
                    tabIndex={0}
                    role="button"
                    aria-pressed="false"
                    className={
                      this.state.count === 0
                        ? "icon prev-icon disable"
                        : "icon prev-icon"
                    }
                    onClick={this.handleClickPrevious}
                    onKeyPress={(e) => this.handleClickPreviousKeyPress(e)}
                  ></span>
                  <div className="count">
                    {this.state.count !== undefined &&
                      `${
                        this.state.count +
                        1 +
                        ` ${this.props.t("common.of")} ` +
                        hitStateData?.length
                      }`}
                    {this.props.hitStateType === "tips" && (
                      <span className="count">
                        {` ${this.props.t("common.tips")}`}
                      </span>
                    )}
                    {this.props.hitStateType === "food" && (
                      <span className="count">
                        {` ${this.props.t("common.foods")}`}
                      </span>
                    )}
                  </div>
                  <span
                    tabIndex={0}
                    role="button"
                    aria-pressed="false"
                    className={
                      this.state.count === this.props.hitStateData?.length - 1
                        ? "icon next-icon disable"
                        : "icon next-icon"
                    }
                    onClick={this.handleClickNext}
                    onKeyPress={(e) => this.handleClickNextKeyPress(e)}
                  ></span>
                </div>
              )}
              {/* Foods and Tips Details Section Ends */}
            </>
          ) : (
            <>
              <ProductDetails
                {...this.props}
                hitStateData={selectedHitStateProduct}
                handleDetailsCart={(productCode, quantity) =>
                  this.handleDetailsCart(productCode, quantity)
                }
                handleDetailsOutofStock={() => this.handleOutOfStock()}
              />
              {hitStateData && hitStateData.length > 1 && (
                <div className="details-pagination-wrapper">
                  {/* <span className="icon prev-icon disable"></span> */}
                  <span
                    tabIndex={0}
                    role="button"
                    className={
                      this.state.count === 0
                        ? "icon prev-icon disable"
                        : "icon prev-icon"
                    }
                    onClick={this.handleClickPrevious}
                    onKeyPress={(e) => this.handleClickPreviousKeyPress(e)}
                  ></span>
                  <div className="count">
                    {this.state?.count !== undefined &&
                      `${
                        this.state?.count +
                        1 +
                        ` ${this.props.t("common.of")} ` +
                        hitStateData?.length
                      }`}
                    {this.props.hitStateType === "product" && (
                      <span className="count">
                        {` ${this.props.t("common.products")}`}
                      </span>
                    )}
                  </div>
                  <span
                    tabIndex={0}
                    role="button"
                    className={
                      this.state?.count === this.props?.hitStateData?.length - 1
                        ? "icon next-icon disable"
                        : "icon next-icon"
                    }
                    onClick={this.handleClickNext}
                    onKeyPress={(e) => this.handleClickNextKeyPress(e)}
                  ></span>
                </div>
              )}
            </>
            // <ProductDetails
            //   handleDetailsCart={(productCode) =>
            //     this.props.handleDetailsCart(productCode)
            //   }
            // />
          )}

          {/* Product Details Section Ends */}
        </div>
      </div>
    );
  }
}

export default DetailsComponent;
